/* ROMANTICO - <rom-now-playing>
   The whole series is already in the DOM: one <a data-np-cover> per product,
   carrying its title and price as data attributes. This element does three
   things and nothing else.

     - moves an index with wrap
     - toggles which cover is visible (and which one is a real link)
     - writes the title, the price and the href of the CTA

   No fetch, no Cart API, no persisted state. Two instances on one page never
   see each other. */
(function () {
  if (window.customElements && customElements.get('rom-now-playing')) return;

  class RomNowPlaying extends HTMLElement {
    connectedCallback() {
      /* Shopify re-renders the whole section on every editor change. */
      if (this._init) return;
      this._init = true;

      this.covers = Array.prototype.slice.call(this.querySelectorAll('[data-np-cover]'));
      this.count = this.covers.length;
      if (this.count < 2) return;

      this.index = 0;
      this.titleEl = this.querySelector('[data-np-field="title"]');
      this.priceEl = this.querySelector('[data-np-field="price"]');
      this.linkEls = Array.prototype.slice.call(this.querySelectorAll('[data-np-field="url"]'));

      this._onClick = this.onClick.bind(this);
      this._onKeydown = this.onKeydown.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      if (this._onClick) this.removeEventListener('click', this._onClick);
      if (this._onKeydown) this.removeEventListener('keydown', this._onKeydown);
    }

    onClick(event) {
      var next = event.target.closest('[data-np-next]');
      var prev = event.target.closest('[data-np-prev]');
      if (!next && !prev) return;
      if (!this.contains(next || prev)) return;
      this.go(next ? 1 : -1);
    }

    onKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      /* Never steal the arrows from a control that uses them itself. */
      var tag = event.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      event.preventDefault();
      this.go(event.key === 'ArrowRight' ? 1 : -1);
    }

    go(step) {
      this.index = (this.index + step + this.count) % this.count;
      this.render();
    }

    render() {
      var active = this.covers[this.index];

      this.covers.forEach(function (cover, i) {
        var isActive = i === this.index;
        cover.classList.toggle('is-active', isActive);
        if (isActive) {
          cover.removeAttribute('tabindex');
          cover.removeAttribute('aria-hidden');
        } else {
          cover.setAttribute('tabindex', '-1');
          cover.setAttribute('aria-hidden', 'true');
        }
      }, this);

      if (this.titleEl) this.titleEl.textContent = active.getAttribute('data-title') || '';

      if (this.priceEl) {
        var price = active.getAttribute('data-price') || '';
        var compare = active.getAttribute('data-compare') || '';
        this.priceEl.textContent = '';
        if (compare) {
          var struck = document.createElement('s');
          struck.textContent = compare;
          this.priceEl.appendChild(struck);
        }
        this.priceEl.appendChild(document.createTextNode(price));
      }

      var href = active.getAttribute('href');
      if (href) {
        this.linkEls.forEach(function (link) {
          link.setAttribute('href', href);
        });
      }
    }
  }

  customElements.define('rom-now-playing', RomNowPlaying);
})();
